@if (!isPrintVersion()) {
  @if (screeningEntityUuid(); as screeningEntityUuid) {
    <button
      nkButton
      [color]="isAllScreeningCaseReviewsCompleted() ? 'secondary' : 'primary'"
      [block]="true"
      class="btn-sm"
      (click)="openScreeningCaseReview(screeningEntityUuid)">
      @if (isAllScreeningCaseReviewsCompleted()) {
        {{ 'screening.screening_overrides.screening_case_table.open_completed_case_btn' | translate }}
      } @else {
        {{ 'screening.screening_overrides.screening_case_table.open_case_btn' | translate }}
      }
      <i class="fa fa-caret-right ms-1"></i>
    </button>
  }
}
